<template>
  <q-card
    v-observe-visibility="{callback: visibilityChanged, once: true}"
    class="q-mb-sm q-mb-sm-md q-mb-lg-lg relative-position widget-card"
    :class="cardClasses"
    :style="cardStyles"
  >
    <q-inner-loading
      :showing="!invisibleCard && loading"
      style="z-index: 1;"
    >
      <loading-spinner />
    </q-inner-loading>

    <div
      v-if="editMode"
      class="absolute-top-right"
      style="top:-8px; right: -12px;z-index: 1;"
    >
      <q-btn-group rounded>
        <q-btn
          v-if="canOpenSettings"
          rounded
          color="white"
          text-color="black"
          icon="mdi-cog-outline"
          @click="isEditingCard = !isEditingCard"
        />
        <q-btn
          rounded
          color="red"
          icon="mdi-close"
          @click="$emit('remove')"
        />
      </q-btn-group>
    </div>

    <div
      :class="{'no-pointer-events': editMode}"
      class="relative-position widget-body"
    >
      <slot name="body" />
    </div>

    <!-- Settings dialog -->
    <content-dialog
      v-model="isEditingCard"
      fullscreen-mobile
      title="Widget Settings"
      transition-show="scale"
    >
      <slot name="settings" />
    </content-dialog>
  </q-card>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility'

import widgetMixin from './mixin'

export default {
  directives: {
    ObserveVisibility
  },
  mixins: [widgetMixin],
  props: {
    styles: {
      type: Object,
      default: () => {
        return {}
      }
    },
    canEdit: {
      required: false,
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: Number,
      default: undefined
    },
    invisibleCard: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove', 'load'],
  data () {
    return {
      isEditingCard: false,
      visible: false
    }
  },
  computed: {
    canOpenSettings () {
      return !!this.$slots.settings
    },
    cardClasses () {
      return {
        'editing-card': this.isEditingCard,
        'bg-transparent shadow-0': this.invisibleCard,
        'bg-black text-white': this.dark
      }
    },
    cardStyles () {
      return {
        'min-height': this.loading && !this.minHeight ? '150px' : `${this.minHeight}px`,
        ...this.styles
      }
    }
  },
  watch: {
    editMode (val) {
      if (!val) {
        this.isEditingCard = false
      }
    }
  },
  methods: {
    visibilityChanged (visibility) {
      if (!this.visible && visibility) {
        this.visible = true
        this.$emit('load')
      }
    }
  }
}
</script>
